import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f0aa0778&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f0aa0778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aa0778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0aa0778')) {
      api.createRecord('f0aa0778', component.options)
    } else {
      api.reload('f0aa0778', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f0aa0778&scoped=true&", function () {
      api.rerender('f0aa0778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Mo2X9fRQS6NY/JS/comp/DocBox.vue"
export default component.exports